import waitlist from './ducks/waitlist.duck';

export default {
  waitlist,
};
